import React, { useContext, useEffect } from 'react';

import { Route, Switch } from 'react-router-dom';

import GlobalStyles from '@xingternal/global-styles';
import { render, config, Miss, withServerData } from '@xingternal/hops';

import { XingFrameProvider } from '@xingternal/xing-frame-provider';
import withStaticData from '@xingternal/xing-frame-provider/withStaticData';
import navigationData from '@xingternal/xing-frame-provider/data/navigation';
import LoggedoutView from '@xingternal/xing-view/LoggedoutView';

import ScrollToTop from './Components/ScrollToTop/ScrollToTop';
import HtmlHead from './Components/HtmlHead/HtmlHead';
import GridWrapper from './Components/GridWrapper/GridWrapper';

import routes from './routes';
import styles from './app.css';
import Store, { StoreProvider } from './store';

const Provider = withStaticData({ navigationData })(XingFrameProvider);

const App = withServerData(({ serverData }) => {
  const { dispatch } = useContext(Store);

  useEffect(() => {
    dispatch({ type: 'HYDRATE_WITH_SERVER_DATA', payload: serverData });
  }, []);

  return (
    <>
      <HtmlHead />
      <ScrollToTop />
      <Provider flavour={'xdl'}>
        <GlobalStyles>
          <LoggedoutView
            homeLink={config.externalUrl}
            className={styles.app}
            hasSidebar={false}
            type={'wide'}
            whiteHeader
            hideButtons
            isStatic
          >
            <Switch>
              {routes
                .filter(({ disabled }) => !disabled)
                .map(({ path, renderFunction, wide }) => (
                  <Route
                    exact
                    path={path}
                    key={path}
                    render={props => (
                      <GridWrapper wide={wide}>
                        {renderFunction(props)}
                      </GridWrapper>
                    )}
                  />
                ))}
              <Miss />
            </Switch>
          </LoggedoutView>
        </GlobalStyles>
      </Provider>
    </>
  );
});

const reducers = {
  root: (state = {}, _action) => state,
};

export default render(
  <StoreProvider>
    <App />
  </StoreProvider>,
  { redux: { reducers } }
);
